"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LOAD_PATH = exports.BUILD = void 0;
var _flatMap = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flat-map"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _i18next = _interopRequireDefault(require("i18next"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _i18nextHttpBackend = _interopRequireDefault(require("i18next-http-backend"));
var _i18nextChainedBackend = _interopRequireDefault(require("i18next-chained-backend"));
var _reactI18next = require("react-i18next");
var _i18nextLocalstorageBackend = _interopRequireDefault(require("i18next-localstorage-backend"));
var _storage = _interopRequireDefault(require("@livongo/utilities/system/storage"));
var _g11n = _interopRequireWildcard(require("../../App/g11n"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const IS_DEV = process.env.NODE_ENV === 'development';
const BUILD = exports.BUILD = {
  key: 'livongo-build-tag',
  value: 'generic'
};
const LOAD_PATH = exports.LOAD_PATH = '/locales/{{lng}}/{{ns}}.json';
var _default = exports.default = function _default() {
  let {
    options = {},
    build = BUILD,
    isDev = IS_DEV
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    options: {},
    build: BUILD,
    isDev: IS_DEV
  };
  const BUILD_TAG_PREV = _storage.default.get({
    key: build.key
  });
  const BACKEND_DEV = {
    backends: [_i18nextHttpBackend.default],
    backendOptions: [{
      loadPath: LOAD_PATH
    }]
  };
  // use browser storage as backend only for remotely published builds
  // then there will be no async fetches unless the build tag changes
  // in local development this will always fetch new i18n files so that
  // adding new translations reloads the latest data and doesn't throw errors for unfound keys
  const BACKEND_PROD = {
    backends: [_i18nextLocalstorageBackend.default, ...BACKEND_DEV.backends],
    backendOptions: [{
      prefix: "".concat(build.key, "-i18n-"),
      store: window.sessionStorage
    }, ...BACKEND_DEV.backendOptions]
  };

  // a deployment created a new build ID, lets clear out browser storage
  // to ensure we re-load the latest translations
  if (!isDev && build.value !== BUILD_TAG_PREV) {
    _storage.default.clear('session');
    _storage.default.set({
      key: build.key,
      value: build.value
    });
  }
  return _i18next.default.use(_i18nextChainedBackend.default).use(_reactI18next.initReactI18next).init(_objectSpread(_objectSpread({
    react: {
      useSuspense: false
    },
    debug: false,
    interpolation: {
      escapeValue: false,
      skipOnVariables: true
    },
    load: 'currentOnly',
    fallbackLng: false,
    partialBundledLanguages: true,
    supportedLngs: _g11n.CODES.LANGUAGES,
    defaultNS: 'ui',
    ns: []
  }, options), {}, {
    lng: options.lng || (0, _g11n.getStoredLang)(),
    backend: (0, _merge.default)(isDev ? BACKEND_DEV : BACKEND_PROD, options.backend),
    resources: (0, _merge.default)(options.resources, (0, _flatMap.default)(_g11n.default).call(_g11n.default, _ref => {
      let {
        languages
      } = _ref;
      return languages;
    }).reduce((acc, _ref2) => {
      let {
        code,
        i18n: translation
      } = _ref2;
      acc[code] = {
        ui: translation
      };
      return acc;
    }, {}))
  }));
};